import { DEFAULT_RIBBON_HALFTONE_MATERIAL, SUBTLE_RIBBON_INTERACTION } from "../interaction";
import { DEFAULT_RIBBON_FRAMING_HEIGHT, LINE_SPACING, OUR_STORY_IDLE_SPEED, PAPER, PREVIOUS_BLOCK_TOP, VERTICAL_ROTATION, } from "./shared";
// The settled width is the minimum. The opening starts 25% broader and
// contracts over the scroll transition; inverse apparent zoom keeps dots crisp.
const STORY_RIBBON_VALUES = {
    background: PAPER,
    zoom: 0.48,
    ribbonWidthScale: 1.2,
    halftoneApparentZoom: 0.42,
    center: [0.5, 0.5],
    rotationDeg: VERTICAL_ROTATION,
    lineExtent: 0.656,
    turbulence: 0.37,
    spacing: LINE_SPACING,
    speed: OUR_STORY_IDLE_SPEED,
    pointerFunnelStrengthScale: 0.3,
    dither: 1,
    spatialColor: 0,
    twistRetention: 1,
    fanSpread: 0,
    twistSpread: 0,
    horizontalStretch: 1,
    unravel: 0,
    funnelWidth: 0.05,
    funnelTaperCeiling: 0.55,
    funnelContourFloor: 0.21,
    funnelTurbulence: 0.37,
    funnelSpacing: LINE_SPACING,
    funnelLineDefinition: 1,
    curveStrength: 0,
    curveProgress: 0,
    mobile: {
        zoom: 0.36,
        lineExtent: 0.82,
        funnelWidth: 0.06,
        halftoneApparentZoom: 0.3,
    },
};
/**
 * Story (prototype OUR_STORY_AURORA_CONFIG): one pinned primary-palette ribbon
 * that begins as a broad vertical funnel, then relaxes into a broad
 * timeline ribbon. Both states share a width floor and material scale.
 */
export const STORY_PRESET = {
    id: "story",
    roles: ["settle"],
    mobileBreakpoint: 900,
    tabletBreakpoint: 1024,
    // Longer mobile framing spaces the folds out without widening the ribbon
    // or changing dot size. Short phone viewports crop this continuous shape.
    framingHeight: DEFAULT_RIBBON_FRAMING_HEIGHT,
    palette: "primary-v2",
    shape: "line",
    halftone: {
        ...DEFAULT_RIBBON_HALFTONE_MATERIAL,
        lineFloor: 0.12,
        bloomGain: 0.75,
    },
    interaction: SUBTLE_RIBBON_INTERACTION,
    initialStateId: "story-funnel",
    states: [
        {
            id: "story-funnel",
            ...STORY_RIBBON_VALUES,
            ribbonWidthScale: 1.5,
            halftoneApparentZoom: 0.336,
            mobile: {
                ...STORY_RIBBON_VALUES.mobile,
                halftoneApparentZoom: 0.24,
            },
            pointerStrengthScale: 0.7,
            funnelStrength: 1,
        },
        {
            id: "story-strip",
            ...STORY_RIBBON_VALUES,
            pointerStrengthScale: 0.9,
            funnelStrength: 0,
        },
    ],
    steps: [
        {
            role: "settle",
            stateId: "story-strip",
            start: PREVIOUS_BLOCK_TOP,
            // Use the full distance to the settle block, including on tall screens.
            end: { target: "top", viewport: 0 },
        },
    ],
};
//# sourceMappingURL=story.js.map